/**
 * Honeypot-сигнал для серверного анти-спам гейта.
 *
 * - Honeypot: скрытый input с именем `__plp_hp`. Реальные пользователи его
 *   не заполняют (он за пределами viewport и tabindex=-1, autocomplete=off).
 *   Бот, парсящий форму, заполняет всё подряд → ловится.
 * Клиент не принимает решение о спаме и не имитирует success: значение всегда
 * отправляется серверу, который сохраняет suspicious-попытку в quarantine.
 */

export const HONEYPOT_NAME = '__plp_hp';

export function buildHoneypot(): HTMLInputElement {
  const input = document.createElement('input');
  input.type = 'text';
  input.name = HONEYPOT_NAME;
  input.tabIndex = -1;
  input.autocomplete = 'off';
  input.setAttribute('aria-hidden', 'true');
  input.style.position = 'absolute';
  input.style.left = '-9999px';
  input.style.opacity = '0';
  input.style.pointerEvents = 'none';
  input.style.height = '0';
  input.style.width = '0';
  return input;
}
